const req = require.context('@/assets/img', false, /\.(svg|png)$/);
const iconMap = {};
req.keys().forEach((key) => {
  const match = key.match(/\.\/([^/]+)\.(svg|png)$/);
  if (!match) return;
  const name = match[1];
  if (/[\u4e00-\u9fa5]/.test(name)) {
    iconMap[name] = req(key);
  }
});
export default iconMap;
